// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"526":"1a8c4de6","540":"1d97265a","613":"248f0833","861":"cf75316e","991":"adf9fbcb"}[chunkId] + ".chunk.js";
};